import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { isFullMoonePersona } from "Utils/Social/socialRules";

/**
 * Whether the viewer's ACTIVE persona is Full Moone, by the one rule the API uses
 * (`SocialConstants.IsFullMoone`): business personas qualify by role, a Customer by the Version
 * of their grant — which `/user-info` already swaps to the active context. Prefer this over
 * `useIsUserInMooneLite().isLiteTier` wherever a rule is about the persona rather than about
 * the person's registration nags: the version alone would call a Hunter or Merchant persona Lite
 * whenever the person's Customer registration is.
 */
export const useIsFullMoonePersona = () => {
  const user = useLoggedInUser();

  return isFullMoonePersona(user?.accessRoleCode, user?.version);
};
